export default "__VITE_ASSET__CawyuI0M__"